import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Divider, Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';

import CircleRoundedIcon from '@mui/icons-material/CircleRounded';

const Container = styled.div`

`;

const P = styled.p`
  font-size: ${props => props.$size ? props.$size : "1.4rem"};
  font-weight: ${props => props.$weight ? props.$weight : "normal"};
  color: ${props => props.$light ? props.theme.colors.mildText : props.theme.colors.text};
  margin: ${props => props.my || "0"} ${props => props.mx || "0"};
  padding: ${props => props.py || "0"} ${props => props.px || "0"};
`

const SectionHeader = styled.h5`
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
  color: #787878;
  font-weight: normal;
`
const FullDivider = styled(Divider)`
  margin: ${props => `${props.my || "auto"} -20px`};
`
const Flex = styled.div`
  display: flex;
  flex-direction: ${props => props.dir || "column"};
  width: ${props => props.width ? props.width : "100%"};
  height: ${props => props.dir && props.dir === "row" ? "auto" : "100%"};
  padding: ${props => props.pad || "0"};
  padding-bottom: ${props => props.padY || "auto"};
  padding-top: ${props => props.padY || "auto"};
  justify-content: ${props => props.justify || "space-between"};
  align-items: ${props => props.align || "center"};
  gap: ${props => props.gap || "0"};
`
const FlexLine = styled.div`
  display: flex;
  flex-direction: ${props => props.dir || "column"};
  width: ${props => props.width ? props.width : "100%"};
  height: ${props => props.dir && props.dir === "row" ? "auto" : "100%"};
  padding: ${props => props.pad || "0"};
  padding-bottom: ${props => props.padY || "auto"};
  padding-top: ${props => props.padY || "auto"};
  justify-content: ${props => props.justify || "space-between"};
  align-items: ${props => props.align || "center"};

  & * {
    display: block;
  }
`

const BasicFlex = styled.div`
  display: flex;
  flex-direction: ${props => props.dir || "row"};
  justify-content: ${props => props.justify ? props.justify : "space-between"};
  align-items: ${props => props.align ? props.align : props.dir === "column" ? "start" : "center"};
  width: ${props => props.width || "100%"};
  margin: ${props => props.my || "0"} ${props => props.mx || "0"};
  padding: ${props => props.py || "0"} ${props => props.px || "0"};
  gap: ${props => props.gap || "0"};
`

const InputLabel = styled.label`
  display: block;
  padding-left: .3rem;
  margin-bottom: ${props => props.dense ? ".4rem" : ".8rem"};
  width: max-content;
  flex-shrink: 0;
  color: ${props => props.theme?.colors?.veryLightText ? props.theme?.colors?.lightText : "gray"};
  font-weight: 500;
  font-size: 1.4rem;
`;

const IconBox = styled.div`
  border-radius: 6px;
  background-color: ${props => props.bg};
  color: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;

  ${props => props.button ? css`
    cursor: pointer; 
    box-shadow: ${props.shadow ? props.theme.shadows[2] : "none"};

    &:hover {
      box-shadow: ${props.theme.shadows[2]};
    }
    ` : ""}

  ${props => props.size === "large" ? css`
    margin-right: 2rem;
    min-width: 5.5rem;
    min-height: 5.5rem;

    svg {
      width: 3rem;
      height: 3rem;
    }
  ` : ""}
  ${props => props.size === "medium" ?  css`
    min-width: 4rem;
    min-height: 4rem;
    margin-right: 1rem;

    svg {
      min-width: 2rem;
      min-height: 2rem;
    }
  `: ""}

  ${props => props.size === "small" ?  css`
    min-width: 3.5rem;
    min-height: 3.5rem;
    /* margin-right: 1rem; */
    padding: .3rem;

    svg {
      min-width: 2rem;
      min-height: 2rem;
    }
  ` : ""}

  ${props => props.size === "mini" ?  css`
    min-width: 2.5rem;
    min-height: 2.5rem;
    /* margin-right: 1rem; */
    padding: .1rem;

    svg {
      min-width: 2rem;
      min-height: 2rem;
    }
  ` : ""}
`;

const LabelUpper = styled.div`
  text-transform: uppercase;
  font-weight: ${props => props.$normal ? "500" : "600"};
  font-size: ${props => props.$size ? props.$size : "1.4rem"};
  color: ${props => props.$light ? props.theme.colors.lightText : props.theme.colors.mildText};
  letter-spacing: ${props => props.$ls ? props.$ls : ".6px"};
`

const Notes = styled.div`
  font-style: italic;
  background-color: ${props => props.theme.palette.grey[100]};
  padding: .5rem 1rem;
  border: 1px solid ${props => props.theme.palette.grey[300]};
  border-radius: 3px;
  min-height: 80px;
  margin-top: .8rem;
`;

const ActionButton = styled(Button)`
  padding: .2rem .5rem;
  min-width: auto;
  background-color: #FCFCFC;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  font-weight: ${props => props.$active ? "600" : "normal"};
`;

const LabelChip = styled.div`
  font-weight: 600;
  background-color: ${props => props.$bc ? props.$bc : 'white'};
  padding: .2rem .6rem;
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 3px;
`;

const ScrollableContainer = styled.div`
  border: 1px solid ${props => props.$border ? props.$border : props.theme.colors.border};
  border-radius: 2px;
  background-color: ${props => props.$bg ? props.$bg : props.theme.colors.lightBg};
  max-height: ${props => props.$expand ? "none" : props.$height ? props.$height : "15rem"};
  overflow-y: auto;
  max-width: 90rem;

  ${props => props.$noBorder ? css/* closed */`
    border: none;
  ` : ""}

  &::-webkit-scrollbar {
    width: 2px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.darkBg};
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.border};
  }
`;

const ServiceItemDisplay = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;
  gap: .3rem;
  .main-title {

  }

  .add-info {
    font-size: 1.2rem;
    color: ${props => props.theme.colors.mildText};
  }
`;

const TableTitle = styled.div`
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  border-radius: 5px;
  color: ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primaryFaint};
  width: fit-content;
  padding: .5rem 2rem;
`

const SectionHeaderBar = styled.div`
  font-weight: 600;
  text-transform: uppercase;
  color: ${props => props.theme.colors.mildText};
  background-color: ${props => props.theme.colors.lightBg};
  border: 1px solid ${props => props.theme.colors.border};
  padding: .5rem 1rem;
  border-radius: 5px;
`

const DotStyles = styled.span`
  color: ${props => props.theme.colors.lightText};
  display: inline-block;
  margin: 0 .5rem;
`


const ServiceItemDisplayTitle = styled.div`

`

const ServiceItemDisplayInfo = styled.div`
  font-size: 1.2rem;
  color: ${props => props.theme.colors.mildText};
`

const DialogContent = styled.div`
  padding: 0 1.6rem;
  line-height: 2;
  font-size: ${props => props.fs ? props.fs : "1.4rem"};
`



const SectionBreak = ({header = "header", my = "1rem"}) => {
  return (
    <Grid size={12}>
      <FullDivider my={my}/>
      <SectionHeader>{header}</SectionHeader>
    </Grid>
  )
}

const autoCompleteDisplayLabel = (title, info) => {
  return (
   <ServiceItemDisplay>
    <ServiceItemDisplayTitle>
      {title}
    </ServiceItemDisplayTitle>
    <ServiceItemDisplayInfo>
      {info}
    </ServiceItemDisplayInfo>
   </ServiceItemDisplay>
  )
}

const DotSeparator = () => {
  return (
    <DotStyles> <CircleRoundedIcon sx={{fontSize: ".8rem"}} /> </DotStyles>
  )
}


export { InputLabel, FlexLine, SectionHeader, Flex, FullDivider, IconBox, BasicFlex, ActionButton, SectionBreak, Container, StyledLink, Notes, LabelChip, ScrollableContainer, SectionHeaderBar, LabelUpper, autoCompleteDisplayLabel, DotSeparator, TableTitle, P, DialogContent };
